module.exports = __webpack_public_path__ + "static/assets/547ab48221ab2547e09ee1294f6b7afa.svg";